<template>
  <div class="order">
    <div class="p-title">H5素材编辑器</div>
    <div class="p-main">
      <div class="header">
        <span class="title">新建H5素材</span>
        <div class="button_box">
          <el-button size="mini" @click="$router.go(-1)">返回</el-button>
          <el-button size="mini" @click="submitData" class="submit">保存</el-button>
        </div>
      </div>
      <div class="add_content clearfix">
        <div class="setting_box">
          <div class="title_box">模版类型</div>
          <div class="template_list clearfix">
            <div v-for="item in templateList" :key="item.type" class="template_box"
                 :class="{check: item.type === selectTemplate}" @click="checkTemplate(item)">
              {{item.name}}
            </div>
          </div>
          <div class="title_box">参数配置</div>
          <el-form class="form_box" label-width="96px">
            <el-form-item label="广告名称" :rules="{ required: true }">
              <el-input v-model="adInfo.materialName" size="mini" style="width: 220px;"></el-input>
            </el-form-item>
            <el-form-item label="单次曝光" :rules="{ required: true }">
              <el-select v-model="adInfo.materialDuration" size="mini" style="width: 220px;">
                <el-option v-for="{dictItemName} in contentTimeList" :value="dictItemName" :label="dictItemName + '秒'"
                           :key="dictItemName"></el-option>
              </el-select>
            </el-form-item>
            <div v-for="(item, index) in formList" :key="index">
              <el-form-item v-if="item.type === 'fullImg'" :label="item.name" :rules="{ required: item.required }">
                <UploadMedia v-model="item.reourceAddress" accept="image/*"></UploadMedia>
              </el-form-item>
              <el-form-item v-if="item.type === 'fullVideo'" :label="item.name" :rules="{ required: item.required }">
                <UploadMedia v-model="item.reourceAddress" accept="video/*"></UploadMedia>
              </el-form-item>
              <div v-if="item.type === 'autoMedia'">
                <el-form-item :label="item.name" :rules="{ required: item.required }">
                  <UploadMedia v-model="item.reourceAddress" accept="video/*,image/*"
                               @success="data=>{autoSuccess(data,item, index)}"></UploadMedia>
                </el-form-item>
                <div class="auto_media">
                  <div class="auto__media_row">
                    <span class="item_label">文件位置</span>
                    <NumberInput v-model="item.left" iconText="X" class="num_input"></NumberInput>
                    <span class="icon_box"></span>
                    <NumberInput v-model="item.top" iconText="X" class="num_input"></NumberInput>
                  </div>
                  <div class="auto__media_row">
                    <span class="item_label">文件大小</span>
                    <NumberInput v-model="item.width" @change="fileSizeChange(item, 'width')" iconText="W"
                                 class="num_input"></NumberInput>
                    <span @click="changeLockScale(item)" class="icon_box">
                      <i v-if="item.lockScale" class="iconfont icon-suo"></i>
                      <i v-else class="iconfont icon-kaisuohuansuo"></i>
                    </span>
                    <NumberInput v-model="item.height" @change="fileSizeChange(item, 'height')" iconText="H"
                                 class="num_input"></NumberInput>
                  </div>
                </div>
              </div>
            </div>
            <div v-for="(item, index) in functionList" :key="index + 'func'">
              <template v-if="item.type === 'dateCount'">
                <el-checkbox v-model="selectFunc.dateCount" @change="(value)=>{countChange(value,item)}"
                             class="func_check">{{item.name}}
                </el-checkbox>
                <template v-if="selectFunc.dateCount">
                  <el-form-item label="截止时间" :rules="{ required: true }">
                    <el-date-picker v-model="item.endTime" type="datetime" value-format="yyyy/MM/dd HH:mm:ss"
                                    placeholder="选择日期时间" size="mini" @change="dateChange"></el-date-picker>
                  </el-form-item>
                  <el-form-item label="字体颜色">
                    <el-color-picker v-model="item.color" size="mini"></el-color-picker>
                  </el-form-item>
                  <el-form-item label="字体大小">
                    <el-input v-model="item.fontSize" size="mini"></el-input>
                  </el-form-item>
                  <div class="form_box_item">
                    <span class="item_label">位置</span>
                    <NumberInput v-model="item.left" iconText="X" class="num_input"></NumberInput>
                    <NumberInput v-model="item.top" iconText="Y" class="num_input"></NumberInput>
                  </div>
                  <div class="form_box_item">
                    <span class="item_label">文字间隔</span>
                    <NumberInput v-model="item.marginBottom" iconText="xp" class="num_input"></NumberInput>
                  </div>
                </template>
              </template>
              <template v-if="item.type === 'bgMusic'">
                <el-checkbox v-model="selectFunc.bgMusic" class="func_check">{{item.name}}</el-checkbox>
                <el-form-item v-if="selectFunc.bgMusic" label="音频" :rules="{ required: true }">
                  <UploadMedia v-model="item.reourceAddress" accept="audio/*"></UploadMedia>
                </el-form-item>
              </template>
            </div>
          </el-form>
        </div>
        <div class="view_box">
          <div class="title_box">效果预览</div>
          <div class="view_content">
            <div class="view_main">
              <p class="width_text">W:1080</p>
              <p class="height_text">H:1920</p>
              <div class="view_div">
                <div v-for="(item, index) in showFormList" :key="index"
                     :class="item.class" :style="getViewStyle(item)">
                  <img v-if="item.type === 'fullImg'" :src="item.reourceAddress" alt="">
                  <video v-if="item.type === 'fullVideo'" :src="item.reourceAddress" loop autoplay></video>
                  <template v-if="item.type === 'autoMedia'">
                    <img v-if="item.sourceType === 'img'" :src="item.reourceAddress" alt="">
                    <video v-if="item.sourceType === 'video'" :src="item.reourceAddress" loop autoplay></video>
                  </template>
                </div>
                <div v-for="(item, index) in functionList" :key="index + 'funcShow'">
                  <div v-if="item.type==='dateCount'&&selectFunc.dateCount" class="data_count" :style="getStyle(item)">
                    <p :style="{marginBottom: changeStyleNum(item.marginBottom) + 'px'}">{{countEndDate.d || 99}}</p>
                    <p :style="{marginBottom: changeStyleNum(item.marginBottom) + 'px'}">{{countEndDate.h || 99}}</p>
                    <p :style="{marginBottom: changeStyleNum(item.marginBottom) + 'px'}">{{countEndDate.m || 99}}</p>
                    <p>{{countEndDate.s || 99}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadMedia from './UploadMedia'
import NumberInput from "./NumberInput";
import { getHtmlStr } from "./util";

export default {
  name: 'add',
  components: { UploadMedia, NumberInput },
  data () {
    return {
      contentTimeList: [],
      templateList: [
        {
          name: '全屏图片', type: 'fullImg', configList: [
            { name: '全屏图片', type: 'fullImg', class: 'full_screen', reourceAddress: '', required: true }
          ]
        },
        {
          name: '全屏视频', type: 'fullVideo', configList: [
            { name: '全屏视频', type: 'fullVideo', class: 'full_screen', reourceAddress: '', required: true }
          ]
        },
        {
          name: '视频+图片', type: 'DIYScreenAdnVideo', configList: [
            { name: '视频/图片', type: 'autoMedia', class: 'absolute_media', reourceAddress: '', required: true },
            { name: '视频/图片', type: 'autoMedia', class: 'absolute_media', reourceAddress: '', required: true }
          ]
        }
      ],
      selectTemplate: 'fullImg',
      adInfo: {},
      formList: [],
      functionList: [
        { type: 'dateCount', name: '倒计时', top: 0, left: 0, endTime: '', color: '', fontSize: 42, marginBottom: 10 },
        { type: 'bgMusic', name: '背景音乐', src: '' },
      ],
      selectFunc: { dateCount: false, bgMusic: false },
      countEndDate: { interval: null, date: '', d: '', m: '', h: '', s: '' }
    }
  },
  computed: {
    showFormList () {
      return this.formList.filter(item => !!item.reourceAddress)
    }
  },
  async created () {
    this.contentTimeList = await this.getContentTimes()
  },
  mounted () {
    this.checkTemplate(this.templateList[0])
  },
  beforeDestroy () {
    this.dateChange()
  },
  methods: {
    checkTemplate (data) {
      this.selectTemplate = data.type
      this.formList = JSON.parse(JSON.stringify(data.configList))
    },
    getStyle (item) {
      let str = ''
      str += 'top:' + this.changeStyleNum(item.top) + 'px;'
      str += 'left:' + this.changeStyleNum(item.left) + 'px;'
      if (item.fontSize) str += 'font-size:' + this.changeStyleNum(item.fontSize) + 'px;'
      if (item.color) str += 'color:' + item.color
      return str
    },
    countChange (value, data) {
      if (value) {
        this.dateChange(data.endTime)
      } else {
        this.dateChange()
      }
    },
    dateChange (value) {
      if (this.countEndDate.interval) {
        clearInterval(this.countEndDate.interval)
        this.countEndDate = { interval: null, date: '', d: '', m: '', h: '', s: '' }
      }
      if (value) {
        this.countFun(value)
      }
    },
    countFun (date) {
      this.countEndDate.date = date
      this.countEndDate.interval = setInterval(() => {
        let timeRange = (+new Date(this.countEndDate.date) - new Date())
        let d, h, m, s
        if (timeRange >= 0) {
          d = Math.floor(timeRange / 1000 / 60 / 60 / 24)
          h = Math.floor(timeRange / 1000 / 60 / 60 % 24)
          m = Math.floor(timeRange / 1000 / 60 % 60)
          s = Math.floor(timeRange / 1000 % 60)
        } else {
          d = 0
          h = 0
          m = 0
          s = 0
        }
        this.countEndDate.d = d
        this.countEndDate.h = h
        this.countEndDate.m = m
        this.countEndDate.s = s
      }, 1000)
    },
    async submitData () {
      const { formList, functionList, selectFunc } = this
      let text = getHtmlStr({ formList, functionList, selectFunc })
      if (!text) return
      const param = {
        ...this.adInfo,
        clienteleGuid: this.$store.state.customer.userInfo.customerId,
        text
      };
      const response = await this.fetch('/design/web/material/v2/add', param, 'POST')
      if (response.code === 0) {
        this.$message.success(response.message)
        this.selectFunc.bgMusic = false
        this.selectFunc.dateCount = false
        this.formList = []
        this.selectTemplate = ''
        this.adInfo = {}
        this.$router.go(-1)
      } else {
        this.$message.error(response.message)
      }
    },
    autoSuccess (data, item, index) {
      const isAssetTypeAnImage = (reourceAddress) => {
        let strList = reourceAddress.split('.')
        let ext = strList[strList.length - 1]
        return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1;
      }
      const streamInfo = JSON.parse(data.videoJson).streams[0]
      if (isAssetTypeAnImage(data.reourceAddress)) {
        item.sourceType = 'img'
      } else {
        item.sourceType = 'video'
      }
      item.originWidth = streamInfo.width
      item.originHeight = streamInfo.height
      this.$set(item, 'top', 0)
      this.$set(item, 'left', 0)
      this.$set(item, 'width', streamInfo.width)
      this.$set(item, 'height', streamInfo.height)
      this.$set(item, 'lockScale', true)
      if (this.formList.length <= 5 && index === this.formList.length - 1) {
        this.formList.push({
          name: '视频/图片',
          type: 'autoMedia',
          reourceAddress: '',
          required: false,
          top: undefined,
          left: undefined,
          width: undefined,
          height: undefined,
          class: 'absolute_media'
        })
      }
    },
    changeLockScale (item) {
      item.lockScale = !item.lockScale
      if (item.lockScale) {
        item.height = item.width / item.originWidth * item.originHeight
      }
      this.$forceUpdate()
    },
    fileSizeChange (data, type) {
      if (data.lockScale) {
        if (type === 'width') {
          data.height = data.width / data.originWidth * data.originHeight
        } else {
          data.width = data.height / data.originHeight * data.originWidth
        }
      }
    },
    getViewStyle (data) {
      if (data.type === 'autoMedia') {
        let str = ''
        if (data.top) str += 'top:' + this.changeStyleNum(data.top) + 'px;'
        if (data.left) str += 'left:' + this.changeStyleNum(data.left) + 'px;'
        if (data.width) str += 'width:' + this.changeStyleNum(data.width) + 'px;'
        if (data.height) str += 'height:' + this.changeStyleNum(data.height) + 'px;'
        return str
      } else {
        return ''
      }
    },
    changeStyleNum (num) {
      return num / 1080 * 315
    },
    numberOperate (data, key, value) {
      if (data[key] !== undefined) {
        data[key] += value
      } else {
        data[key] = 1
      }
      this.$forceUpdate()
    },
    async getContentTimes () { // 获取购买时长列表
      if (!this.$store.state.bmap.labelTimeSlotList.length) await this.$store.dispatch('getTimeSlotList')
      return this.$store.state.bmap.labelTimeSlotList || []
    }
  }
}
</script>


<style scoped lang="scss">
.p-main {
  padding: 20px;
  color: #282729;
  .header {
    height: 45px;
    .title {
      font-size: 18px;
      font-weight: 600;
    }
    .button_box {
      float: right;
      button {
        width: 80px;
        background: #FFF;
        color: #FF3973;
        border-color: #FF3973;
        &.submit {
          color: #FFF;
          background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%);
        }
      }
    }
  }
  .add_content {
    height: calc(100% - 26px);
    .title_box {
      line-height: 40px;
      font-size: 14px;
      font-weight: 600;
      padding: 0 20px;
      background: #F5F5F5;
      border-bottom: 1px solid #E9E9E9;
    }
    .setting_box {
      float: left;
      width: 370px;
      height: 100%;
      border: 1px solid #E9E9E9;
      .template_list {
        padding: 0 28px;
        border-bottom: 1px solid #E9E9E9;
      }
      .template_box {
        float: left;
        width: 90px;
        height: 90px;
        text-align: center;
        line-height: 90px;
        color: #666;
        font-size: 14px;
        border-radius: 4px;
        background: #F5F5F5;
        margin: 10px 5px;
        cursor: pointer;
        &.check {
          background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%);
        }
      }
      .form_box {
        padding: 20px;
        height: calc(100% - 200px);
        overflow-y: auto;
        .auto_media {
          margin-top: -12px;
          margin-bottom: 10px;
          background: #F5F5F5;
          padding: 10px;
          border: 1px solid #E9E9E9;
          .auto__media_row {
            margin-top: 10px;
            .icon_box {
              display: inline-block;
              width: 20px;
              text-align: center;
              color: #999;
              i {
                cursor: pointer;
                font-size: 16px;
              }
            }
            .num_input:last-child {
              margin-left: 0;
            }
            &:first-child {
              margin-top: 0;
            }
          }
          .item_label {
            display: inline-block;
            width: 90px;
            height: 40px;
            line-height: 40px;
            border-radius: 4px;
            text-align: center;
            color: #282729;
            border: 1px solid rgba(233, 233, 233, 1);
            background: #FFF;
          }
          .num_input {
            width: 90px;
            margin-left: 10px;
          }
        }
        .form_box_item {
          margin-bottom: 10px;
          .item_label {
            display: inline-block;
            width: 90px;
            height: 40px;
            line-height: 40px;
            border-radius: 4px;
            text-align: center;
            color: #282729;
            font-weight: 600;
            border: 1px solid rgba(233, 233, 233, 1);
          }
          .num_input {
            width: 104px;
            margin-left: 10px;
          }
          .text_input {
            width: 218px;
            margin-left: 10px;
          }
        }
        .func_check {
          margin-bottom: 10px;
        }
        ::v-deep {
          .el-form-item {
            margin-bottom: 10px;
            border: 1px solid #E9E9E9;
            border-radius: 4px;
            padding: 5px;
            .el-form-item__label {
              display: inline-block;
              width: 100px;
              text-align: center;
              color: #282729;
              font-weight: 600;
              border-right: 1px solid #e9e9e9;
              padding: 0 10px 0 0;
              margin-top: 5px;
              line-height: 20px;
            }
            .el-input__inner {
              padding-left: 15px;
            }
            .el-form-item__content {
              line-height: 28px;
              height: 28px;
              .el-select {
                .el-select__tags {
                  padding-left: 10px
                }
              }
            }
            .icon-biaodan-shijian {
              color: #c0c4cc
            }
            .el-select, .el-input {
              &.input-date {
                width: 92px;
                padding-left: 0;
                margin-right: 5px;
                > input {
                  padding-left: 10px
                }
              }
              input {
                border: none;
                padding-right: 0;
                &:focus {
                  border-bottom: none !important
                }
              }
              .el-input__prefix {
                display: none
              }
            }
            .el-select .el-tag {
              margin: 2px 2px 2px 0
            }
          }
        }
      }
    }
    .view_box {
      float: left;
      width: calc(100% - 380px);
      margin-left: 10px;
      height: 100%;
      border: 1px solid #E9E9E9;
      .view_content {
        height: calc(100% - 40px);
        display: flex;
        justify-content: center; //子元素水平居中
        align-items: center; //子元素垂直居中
        overflow: auto;
        .view_main {
          position: relative;
          width: 317px;
          height: 562px;
          border: 1px solid #ccc;
          .width_text {
            position: absolute;
            top: -20px;
            left: 0;
            width: 100%;
            text-align: center;
            line-height: 20px;
            color: #C0C4CC;
          }
          .height_text {
            position: absolute;
            top: 0;
            left: -20px;
            width: 20px;
            line-height: 20px;
            color: #C0C4CC;
            writing-mode: vertical-rl;
            padding-top: 224px;
          }
          .view_div {
            position: relative;
            width: 100%;
            height: 100%;
            overflow: auto;
          }
          .full_screen {
            width: 100%;
            height: 100%;
            img {
              width: 100%;
              height: 100%;
              vertical-align: bottom;
            }
            video {
              width: 100%;
              height: 100%;
              object-fit: fill;
            }
          }
          .absolute_media {
            position: absolute;
            img {
              width: 100%;
              height: 100%;
              vertical-align: bottom;
            }
            video {
              width: 100%;
              height: 100%;
              object-fit: fill;
            }
          }
          .data_count {
            position: absolute;
            text-align: center;
            line-height: 1.2;
          }
        }
      }
    }
  }

}
</style>
